const notifications = {
    accountLimitExceeded: {
        title: 'Has superado el límite de depósito mensual',
        description: 'Mejora tu cuenta para que puedas seguir disfrutando de los '
            + 'beneficios de la inversión inmobiliaria.'
    },
    accountStatementReady: {
        title: 'Tu estado de operaciones está listo',
        description: 'El resumen de tus inversiones del mes pasado ya se encuentra '
            + 'disponible, dale un vistazo.'
    },
    automaticRentReleaseFailed: {
        title: 'Revisa tu información fiscal',
        description: 'No pudimos generar tu factura ni liberar tus rentas. Ve a Mi perfil,'
            + ' Facturación para validar tus datos. Si la información es correcta,'
            + ' comunícate con Soporte desde Ayuda.'
    },
    automaticRentReleaseFailedFiscalRegimeNotAllowed: {
        title: 'Tu régimen fiscal no es compatible',
        description: 'El régimen registrado en tu cuenta no permite generar tu factura automática.'
            + ' Revisa que coincida con tu Constancia de Situación Fiscal y que corresponda a'
            + ' Arrendamiento, RESICO o RIF.'
    },
    automaticRentReleaseFailedFiscalZipCodeIsNotSet: {
        title: 'Tu código postal fiscal no coincide',
        description: 'El código postal registrado en 100 Ladrillos es diferente al que aparece en '
            + 'tu Constancia de Situación Fiscal. Para generar tu factura automática y liberar tus '
            + 'rentas, ambos datos deben coincidir. Consulta tu Constancia de Situación Fiscal más '
            + 'reciente y actualiza el dato registrado en tu cuenta.'
    },
    automaticRentReleaseFailedFiscalZipCodeNotRegistered: {
        title: 'Código postal fiscal no está registrado ante el SAT',
        description: 'No pudimos generar tu factura porque tu información fiscal ante el SAT no '
            + 'incluye un código postal. Comunícate con nuestro equipo de Soporte para que te '
            + 'ayudemos a revisar tu información y te indiquemos cómo actualizarla. Una vez '
            + 'corregida, podrás liberar tus rentas.'
    },
    automaticRentReleaseSuccessful: {
        title: 'Tus facturas ya están listas',
        description: 'Te las enviamos por correo. Revísalo para descargarlas y '
            + 'consultar el detalle de tus ingresos liberados.'
    },
    automaticRentReleaseWithoutInvoiceSuccessful: {
        title: 'Tus ingresos ya están en tu fondo',
        description: 'Liberaste tus rentas sin factura, por lo que se aplicó el cargo compensatorio '
            + 'correspondiente. Para tus próximas rentas, considera utilizar la facturación para evitar '
            + 'este cargo.'
    },
    basicLevelReached: {
        title: 'Ya tienes todo listo para comenzar a invertir',
        description: 'Hemos validado tu información y tu cuenta ya está lista para '
            + 'poner a trabajar tu dinero. Comienza explorando algunas propiedades.'
    },
    changeEmailVerification: {
        title: '¿Estás cambiando tu correo electrónico?',
        description: 'Hemos detectado que estás realizando un cambio en tu correo '
            + 'electrónico. Si este cambio es correcto, continúa con las instrucciones que hemos enviado '
            + 'a tu correo electrónico anterior. Si no has solicitado un cambio, contacta a nuestro '
            + 'equipo de soporte.'
    },
    changePhoneConfirmation: {
        title: 'Has cambiado tu teléfono con éxito',
        description: 'Hemos realizado con éxito el cambio de tu número de teléfono. '
            + 'A partir de ahora, utilizaremos este nuevo número para enviarte los códigos necesarios '
            + 'para autorizar tus transacciones dentro de 100 Ladrillos.'
    },
    curpRejected: {
        title: 'La CURP ha sido rechazada',
        description: 'La CURP que nos proporcionaste no es válida, pero no te '
            + 'preocupes, para continuar puedes proporcionarnos una CURP válida en tu perfil.'
    },
    depositFunds: {
        title: 'Has agregado fondos a tu cuenta',
        description: 'Tu transferencia ya se ha reflejado en tu cuenta, ahora tienes '
            + 'más recursos disponibles para invertir en excelentes oportunidades.'
    },
    identificationRejected: {
        title: 'Tu identificación no pudo ser validada',
        description: 'No fue posible confirmar tu identificación. '
            + 'Vuelve a subirla desde la seccion de Mi perfil.'
    },
    limitlessLevelReached: {
        title: 'Tu cuenta está lista para invertir sin límites',
        description: 'Se ha completado la validación de tu documentación y hemos '
            + 'mejorado tu cuenta para invertir sin límites.'
    },
    pendingLeaseIncomeToRelease: {
        title: 'Tus rentas ya están disponibles',
        description: 'Ya cobramos las rentas de tus propiedades. Sube tu factura antes de que '
            + 'termine el mes para recibirlas de inmediato.'
    },
    readyToSign: {
        title: 'Tienes documentos por firmar',
        description: 'Debido a los cambios que realizaste en tus datos, necesitamos '
            + 'que vuelvas a firmar tus documentos. Por favor, accede a tu perfil y completa la firma.'
    },
    successfulEmailUpdate: {
        title: 'Has cambiado tu correo electrónico con éxito',
        description: 'Esto significa que ahora iniciarás sesión con tu nuevo correo y '
            + 'recibirás todas nuestras comunicaciones, noticias y actualizaciones importantes en esta '
            + 'nueva dirección.'
    }
};
export default notifications;
